let firstLoadedPage = 1;
let lastLoadedPage = 1;
let targetProductId = null;

function loadProducts() {
  const urlParams = new URLSearchParams(window.location.search);
  targetProductId = urlParams.get('to');

  if (targetProductId) {
    scrollToProduct(targetProductId);
  }

  const loadingBtn = document.querySelector('.AjaxinatePaginationNext');
  const loadPrevBtn = document.querySelector('.AjaxinatePaginationPrev .load-more-button');

  if (loadingBtn) {
    loadingBtn.addEventListener("click", loadMoreProducts);
  }

  if (loadPrevBtn) {
    loadPrevBtn.addEventListener("click", function (e) {
      e.preventDefault();
      loadPreviousProducts();
    });
  }

  // Initialize the firstLoadedPage and lastLoadedPage
  firstLoadedPage = lastLoadedPage = parseInt(document.querySelector('[data-current-page]').value);

  updateLoadPreviousButtonVisibility();
  setTimeout(initializeNewProductSliders, 0);
}

function scrollToProduct(productId) {
  // Find all elements with this product ID
  const productElements = document.querySelectorAll(`[data-product-id="${productId}"]`);

  // Find the visible one
  const visibleProduct = Array.from(productElements).find(element =>
    window.getComputedStyle(element).display !== 'none'
  );

  if (visibleProduct) {
    visibleProduct.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    loadMoreProductsUntilFound(productId);
  }
}

function loadMoreProductsUntilFound(productId) {
  const totalPages = parseInt(document.querySelector('[data-total-pages]').value);

  if (lastLoadedPage < totalPages) {
    loadMoreProducts().then(() => {
      const productElement = document.querySelector(`[data-product-id="${productId}"]`);

      if (productElement) {
        productElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        loadMoreProductsUntilFound(productId);
      }
    });
  }
}

function updateURLHash(searchParams) {
  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
}

function loadMoreProducts() {
  return new Promise((resolve, reject) => {
    const loadingBtn = document.querySelector('.AjaxinatePaginationNext .load-more-button');
    if (loadingBtn) {
      loadingBtn.classList.add('disabled');
      setLoadingText(loadingBtn);
    }

    let totalPages = parseInt(document.querySelector('[data-total-pages]').value),
      nextUrlSelector = document.querySelector('[data-next-url]');

    if (lastLoadedPage < totalPages) {
      let nextPage = lastLoadedPage + 1;
      let nextUrl = nextUrlSelector.value;

      fetch(nextUrl)
        .then(response => response.text())
        .then((responseText) => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(responseText, 'text/html');
          const newProducts = newDocument.querySelectorAll('#product-grid .grid__item');

          if (document.querySelector('#product-grid')) {
            newProducts.forEach(product => {
              document.querySelector('#product-grid').appendChild(product.cloneNode(true));
            });
            setTimeout(initializeNewProductSliders, 0);
          }

          lastLoadedPage = nextPage;
          document.querySelector('[data-current-page]').value = lastLoadedPage;
          nextUrlSelector.value = nextUrlSelector.value.replace(/page=[0-9]+/, 'page=' + (nextPage + 1));

          if (loadingBtn) {
            loadingBtn.classList.remove('disabled');
            resetButtonText(loadingBtn, 'loadMoreText');
          }
          if (lastLoadedPage === totalPages) {
            loadingBtn.style.display = 'none';
          }

          let queryString  = window.location.search;
          if(queryString == ''){
            queryString = queryString.replace('?','') + ('page=' + nextPage);
          }else{
            if(queryString.indexOf('?')> -1){
              if(queryString.indexOf('page=') >-1){
                queryString = queryString.replace(`page=${nextPage-1}` , (  'page='+nextPage)) ;

              }else{
                queryString += '&page=' + nextPage;
              }
            }
          }
          queryString = queryString.replace('?', '');
          updateURLHash(queryString);

          // updateProductsGrid();
          updateLoadPreviousButtonVisibility();
          resolve();
        }).catch((e) => {
          console.error('Error loading more products:', e);
          if (loadingBtn) {
            loadingBtn.classList.remove('disabled');
            resetButtonText(loadingBtn, 'loadMoreText');
          }
          reject(e);
        });
    } else {
      resolve();
    }
  });
}

function setLoadingText(button) {
  if (button) {
    button.innerHTML = button.dataset.loadingText + '<span class="loading-dots"><span>.</span><span>.</span><span>.</span></span>';
    button.classList.add('loading');
  }
}

function resetButtonText(button, textDataAttribute) {
  if (button) {
    button.textContent = button.dataset[textDataAttribute];
    button.classList.remove('loading');
  }
}

function loadPreviousProducts() {
  const prevUrlSelector = document.querySelector('.AjaxinatePaginationPrev .load-more-button');
  if (prevUrlSelector) {
    prevUrlSelector.classList.add('disabled');
    setLoadingText(prevUrlSelector);
  }

  if (firstLoadedPage > 1) {
    prevUrlSelector.classList.add('loading-products');
    let prevPage = firstLoadedPage - 1;
    let prevUrl = prevUrlSelector.href.replace(/page=[0-9]+/, 'page=' + prevPage);

    // Store the current scroll position and height of the product grid
    const scrollPosition = window.pageYOffset;
    const productGrid = document.querySelector('#product-grid');
    const initialHeight = productGrid.offsetHeight;

    fetch(prevUrl)
      .then(response => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(responseText, 'text/html');
        const newProducts = Array.from(newDocument.querySelectorAll('#product-grid .grid__item'));

        if (productGrid) {
          // Create a document fragment to hold the new products
          const fragment = document.createDocumentFragment();
          newProducts.forEach(product => {
            fragment.appendChild(product.cloneNode(true));
          });

          // Insert all new products at once at the beginning
          productGrid.insertBefore(fragment, productGrid.firstChild);

          // Calculate the height difference and adjust scroll position
          const newHeight = productGrid.offsetHeight;
          const heightDifference = newHeight - initialHeight;
          window.scrollTo(0, scrollPosition + heightDifference);

          setTimeout(initializeNewProductSliders, 0);
        }

        // Update the first loaded page and previous button URL
        firstLoadedPage = prevPage;
        document.querySelector('[data-current-page]').value = firstLoadedPage;
        prevUrlSelector.href = prevUrlSelector.href.replace(/page=[0-9]+/, 'page=' + (prevPage - 1));

        prevUrlSelector.classList.remove('loading-products');
        if (firstLoadedPage === 1) {
          prevUrlSelector.style.display = 'none';
        }

        // Update next button visibility
        const loadingBtn = document.querySelector('.AjaxinatePaginationNext .load-more-button');
        if (loadingBtn && loadingBtn.style.display === 'none') {
          loadingBtn.style.display = '';
        }

        if (prevUrlSelector) {
          prevUrlSelector.classList.remove('disabled');
          resetButtonText(prevUrlSelector, 'loadPreviousText');
        }

        // updateProductsGrid();
        updateLoadPreviousButtonVisibility();
      }).catch((e) => {
        console.error('Error loading previous products:', e);
        if (prevUrlSelector) {
          prevUrlSelector.classList.remove('disabled');
          resetButtonText(prevUrlSelector, 'loadPreviousText');
        }
      });
  }
}

function initializeNewProductSliders() {
  const newSliders = document.querySelectorAll('.product-card-carousel:not(.flickity-enabled)');
  let flickityOptions = {
    pageDots: true,
    prevNextButtons: false,
    wrapAround: false,
    cellAlign: 'left',
    contain: true,
    adaptiveHeight: true,
    watchCSS: true
  };

  if (window.innerWidth > 990) {
    flickityOptions = {
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true,
      cellAlign: 'left',
      contain: true,
      adaptiveHeight: true,
      watchCSS: true
    };
  }

  newSliders.forEach((slider) => {
    const flickityInstance = new Flickity(slider, flickityOptions);

    // Force a resize event to ensure proper layout
    setTimeout(() => {
      flickityInstance.resize();
    }, 100);
  });
}

function updateLoadPreviousButtonVisibility() {
  const loadPrevBtn = document.querySelector('.AjaxinatePaginationPrev .load-more-button');
  if (loadPrevBtn) {
    loadPrevBtn.style.display = firstLoadedPage <= 1 ? 'none' : '';
  }
}

window.addEventListener('resize', initializeNewProductSliders); // run on screen resize
